import { createAction, props } from '@ngrx/store';
import { NotificationPreference } from '../../models/notification-preference';
import { NotificationPreferenceRequest } from '../../models/notification-preference-request';
import { NotificationType } from '../../models/notification-type';

export const getNotificationPreferences = createAction('[Notification Preference] Get Notification Preferences');

export const getNotificationPreferencesSuccess = createAction(
  '[Notification Preference] Get Notification Preferences Success',
  props<{ preferences: NotificationPreference }>()
);

export const getNotificationPreferencesFailure = createAction(
  '[Notification Preference] Get Notification Preferences Failure',
  props<{ error: unknown }>()
);

export const saveNotificationPreferences = createAction(
  '[Notification Preference] Save Notification Preferences',
  props<{ notificationPreferenceRequest: NotificationPreferenceRequest; successRoute?: string }>()
);

export const saveNotificationPreferencesSuccess = createAction(
  '[Notification Preference] Save Notification Preferences Success',
  props<{ preferences: NotificationPreference; successRoute?: string }>()
);

export const saveNotificationPreferencesFailure = createAction(
  '[Notification Preference] Save Notification Preferences Failure',
  props<{ error: unknown }>()
);

export const getNotificationTypes = createAction('[Notification Preference] Get Notification Types');

export const getNotificationTypesSuccess = createAction(
  '[Notification Preference] Get Notification Types Success',
  props<{ notificationTypes: NotificationType[] }>()
);

export const getNotificationTypesFailure = createAction(
  '[Notification Preference] Get Notification Types Failure',
  props<{ error: unknown }>()
);
